export default "__VITE_ASSET__CsLfssJs__"